import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Header from 'components/header';
import { RouteConstants } from "components/route/RouteConstants";
import AuthCallback from 'components/user/AuthCallback';
import AuthError from 'components/library/errors/auth-error';
import Unauthorized from 'components/library/errors/unauthorised';
import OverView from './overview';
import ConfigInitializer from "components/user/services/ConfigInitializer";
import "assets/stylesheets/index.scss";
import "assets/fonts/Graphik/Graphik-Semibold.otf";
import Logout from "components/user/Logout";
import Errors from "components/errors/Errors";
import ErrorWrapper from "components/errors/error-wrapper";
import ErrorBoundaryWrapper from "components/library/error-boundary-wrapper";

function App() {
  //JSX error handling 
  try {
    return (
      <BrowserRouter>
        <ConfigInitializer>
          <Header />
          <ErrorWrapper />
          <ErrorBoundaryWrapper>
            <Routes>
              <Route path={RouteConstants.AUTH_ERROR} element={<AuthError />} />
              <Route path={RouteConstants.UNAUTHORIZED} element={<Unauthorized />} />
              <Route path={RouteConstants.AUTH_CALLBACK} element={<AuthCallback />} />
              <Route path={RouteConstants.LOGOUT} element={<Logout />} />
              <Route path="/" element={<OverView />} />
              <Route path="*" element={<Navigate to="/" />} />
            </Routes>
          </ErrorBoundaryWrapper>
        </ConfigInitializer>
        {/*  */}
      </BrowserRouter>
    );
  } catch (e) {
    return (
      <Errors errorCode={0}/>
    )
  }
  
}

export default App;
